import { useTheme, useMediaQuery } from '@mui/material';

export default function useResponsive() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTabletDown = useMediaQuery(theme.breakpoints.down('md'));

  return {
    isMobile,
    isTabletDown,
    isDesktop: !isTabletDown,
  };
}
